import React from 'react';

import StatusBox from '../../src/Components/Global/StatusBar';
import MenuBar from '../../src/Components/Global/Main_Menu';

import MyFooter from '../../src/Components/Global/Footer';

import { useContext } from 'react';
import { ContextProvider, Context_Navigation, Context_Explore_Laws } from '../../src/Data/ContextProvider';

import Select_Law from '../../src/Components/Analysis/Select_Law';

import Law_Regulation_E_Main from '../../src/Components/Legal_Topics/Folder_Regulation_E/LawPage_Regulation_E';

import Law_Remittance_Transfers_Reg_E_Main from '../../src/Components/Legal_Topics/Folder_Remittance_Transfers_Regulation_E/LawPage_Remittance_Transfers_Regulation_E';


export default function Explore_Laws_Main() {


    return (
        <div>
            <ContextProvider>
                <Explore_Laws />
            </ ContextProvider>

        </div>
    );
}


function Explore_Laws() {
    const [Navigation_GVars, Update_Navigation_GVars] = useContext(Context_Navigation);
    const [Explore_Laws_GVars, Update_Explore_Laws_GVars] = useContext(Context_Explore_Laws);



    return (
        <div>
            <MyFooter />
            <MenuBar />
            <div className='page_Tracker'> >> Home >> Explore Relevant Laws </div>
            {Navigation_GVars.statusBox ? <> <StatusBox /> </> : <></>}


            <Law_Remittance_Transfers_Reg_E_Main /> 



        </div >
    );
}




